/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uVolumeMute = A4uVolumeMute;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uVolumeMute(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M12,27a10.98316,10.98316,0,0,1,4-8.47839V5a.72593.72593,0,0,0-1.19434-.57129L8.167,11.22839c-.439.4469-.72619.84485-1.42187.84485H1a1,1,0,0,0-1,1v9.92285a1,1,0,0,0,1,1H6.74512c.69641,0,.99609.41138,1.42187.84485L12.17188,28.943A11.02155,11.02155,0,0,1,12,27Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M23,18.1A8.9,8.9,0,1,0,31.8999,27,8.90007,8.90007,0,0,0,23,18.1ZM16,27a6.93453,6.93453,0,0,1,1.47461-4.252L27.252,32.52539A6.96595,6.96595,0,0,1,16,27Zm12.52539,4.252-9.77734-9.77734A6.96595,6.96595,0,0,1,28.52539,31.252Z"
  }));
}